export function getAllDomains(env = process.env.NODE_ENV) {
  const nonProductionTLDs = {
    development: ".test",
    test: ".test",
    staging: "-staging.net",
  }

  return ["activeden", "audiojungle", "themeforest", "videohive", "graphicriver", "3docean", "codecanyon", "photodune"]
    .map((site) => `${site}${nonProductionTLDs[env] || ".net"}`)
    .concat([
      "market.styleguide.envato.com",
      "elements.envato.com",
      "author.envato.com",
      "envato.com",
      "account.envato.com",
      "forums.envato.com",
    ])
}
